import { useEffect } from 'react'
import { useRecoilState, useRecoilValue } from 'recoil'
import {
  listPointState,
  selectedPoint,
  selectedSubImageState
} from 'store/buildingStore'
import { KrpanoInitProps } from 'types/krpano'
import Krpano from 'utils/krpano'

export default function usePreviewKrpano() {
  const currentSelectedPoint = useRecoilValue(selectedPoint)
  const [points] = useRecoilState(listPointState)
  const [selectedSubImage] = useRecoilState(selectedSubImageState)
  const krpanoOnreadyCallback = async (
    krpano: any,
    krpanoInitProps: KrpanoInitProps
  ) => {
    // get initial variables when embed pano
    const { h, v, z, previewUrl, tilesUrl, multires, imageUrl } =
      krpanoInitProps

    const varString = `layer[set_first_view_button].visible=true&view.hlookat=${h}&view.vlookat=${v}&view.fov=${z}`

    await krpano.call(
      `loadpano('/krpano/xml-assets/pano_preview.xml','${varString}',IGNOREKEEP,BLEND(1));`
    )
    const sceneName = Krpano.getScenceNameByFileId(
      currentSelectedPoint,
      points,
      selectedSubImage
    )
    const screenString = Krpano.generateSceneXML({
      sceneName,
      tilesUrl: tilesUrl || undefined,
      multires: multires || undefined,
      s3Path: imageUrl,
      thumbnailUrl: previewUrl || ''
    })

    krpano.call(`loadxml(${screenString}, null, MERGE);`)

    krpano.call(`load_scene(${sceneName},${h},${v},${z})`)
  }

  const embedpano = (krpanoInitProps: KrpanoInitProps) => {
    const embedpano = document.getElementById('embedpano-preview') as any
    const target = document.getElementById('preview-krpano-container')
    const { imageUrl, previewUrl, z, h, v, multires, tilesUrl } =
      krpanoInitProps

    if (target) {
      if (!embedpano) {
        ;(window as any)?.embedpano({
          id: 'embedpano-preview',
          xml: null,
          target: 'preview-krpano-container',
          html5: 'auto+webgl',
          mwheel: false,
          bgcolor: '#FFFFFF',
          onready: (krpano: any) => {
            krpanoOnreadyCallback(krpano, krpanoInitProps)
          }
        })
      } else {
        const sceneName = Krpano.getScenceNameByFileId(
          currentSelectedPoint,
          points,
          selectedSubImage
        )
        if (embedpano.get(`scene[${sceneName}]`) === null) {
          const screenString = Krpano.generateSceneXML({
            sceneName,
            tilesUrl: tilesUrl || undefined,
            multires: multires || undefined,
            s3Path: imageUrl,
            thumbnailUrl: previewUrl || ''
          })
          embedpano.call(`loadxml(${screenString}, null, MERGE);`)
        }
        embedpano.call(`load_scene(${sceneName},${h},${v},${z})`)
      }
    }
  }

  useEffect(() => {
    return () => {
      Krpano.UnmountPanoPreview()
    }
  }, [])

  return {
    embedpano,
    currentSelectedPoint
  }
}
